var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c(
        "v-form",
        { ref: "form" },
        [
          this.formaPodnikania.pkId == 1 || this.formaPodnikania.pkId == 2
            ? [
                _c(
                  "v-card",
                  { staticClass: "mt-24px card" },
                  [
                    this.formaPodnikania.pkId == 1
                      ? [
                          _c(
                            "v-row",
                            {
                              staticClass: "mb-2",
                              attrs: { "no-gutters": "" }
                            },
                            [
                              _c("v-col", [
                                _c("h2", { staticClass: "left mr-3" }, [
                                  _vm._v("Pridanie štatutárov")
                                ])
                              ])
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "mb-2",
                              attrs: { "no-gutters": "" }
                            },
                            [
                              _c("v-col", { attrs: { cols: "8" } }, [
                                _c("p", { staticClass: "f16 gs100 mb-0" }, [
                                  _vm._v(
                                    " Na zadávanie vzdialeného podpisu musia mať všetci štatutári vytvorený účet v Klientskej zóne a prejsť procesom overenia totožnosti. "
                                  )
                                ]),
                                _c("br"),
                                _c(
                                  "p",
                                  {
                                    staticClass: "f16 gs100 mb-0",
                                    staticStyle: { "font-weight": "700" }
                                  },
                                  [
                                    _vm._v(
                                      " Štatutárom, ktorí nemajú vytvorený účet, príde e-mailom link na registráciu. "
                                    )
                                  ]
                                ),
                                _c("br"),
                                _c(
                                  "p",
                                  {
                                    staticClass: "f16 gs100 mb-0",
                                    staticStyle: { "font-weight": "700" }
                                  },
                                  [
                                    _vm._v(
                                      " V prípade, že je potrebné pridať profil v Klientskej zóne, je možné tak urobiť po prihlásení kliknutím na rozbaľovacie menu profilu (v pravej hornej časti) a následne kliknutím na „Pridať profil“. "
                                    )
                                  ]
                                ),
                                _c("br"),
                                _c(
                                  "p",
                                  {
                                    staticClass: "f16 gs100 mb-0",
                                    staticStyle: { "font-weight": "700" }
                                  },
                                  [
                                    _vm._v(
                                      ' Konečného uživateľa výhod vyberte zo zoznamu štatutárov. V prípade, že konečný užívateľ výhod nie je štatutárom firmy, pridajte ho cez tlačidlo "Pridať nového KUV". '
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _vm._l(_vm.users, function(user, index) {
                            return [
                              _c(
                                "v-row",
                                {
                                  key: "user-name" + index,
                                  staticClass: "mt-4 no-padding-top-bottom"
                                },
                                [
                                  _c("v-col", { attrs: { cols: "8" } }, [
                                    _c(
                                      "span",
                                      { staticClass: "f18 white100" },
                                      [
                                        _vm._v(
                                          _vm._s(user.meno) +
                                            " " +
                                            _vm._s(user.priezvisko)
                                        )
                                      ]
                                    ),
                                    !!user.popis
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "ml-2",
                                            class: {
                                              "sumar-info":
                                                user.popisFarba == 0,
                                              "sumar-success":
                                                user.popisFarba == 1,
                                              "sumar-warning":
                                                user.popisFarba == 2
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "btn-help",
                                                class: {
                                                  "sumar-info":
                                                    user.popisFarba == 0,
                                                  "sumar-success":
                                                    user.popisFarba == 1,
                                                  "sumar-warning":
                                                    user.popisFarba == 2
                                                },
                                                attrs: { size: "16px" }
                                              },
                                              [_vm._v("$check_circle ")]
                                            ),
                                            _vm._v(" " + _vm._s(user.popis))
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  key: "user" + index,
                                  staticClass: "mt-2 no-padding-top-bottom"
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass:
                                          "dynamic-input-control required",
                                        attrs: {
                                          label: "E-mail",
                                          rules: [
                                            _vm.rules.email,
                                            _vm.rules.required
                                          ],
                                          outlined: "",
                                          disabled: !user.emailEnabled
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.dirty = true
                                          }
                                        },
                                        model: {
                                          value: _vm.users[index].email,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.users[index],
                                              "email",
                                              $$v
                                            )
                                          },
                                          expression: "users[index].email"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-autocomplete", {
                                        staticClass: "dynamic-input-control",
                                        attrs: {
                                          items: _vm.vztahyKFirme,
                                          label: "Vzťah k firme",
                                          outlined: "",
                                          "hide-details": "",
                                          "item-text": "displayMember",
                                          "item-value": "valueMember",
                                          disabled: !!user.popis
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.dirty = true
                                          }
                                        },
                                        model: {
                                          value: _vm.users[index].funkcia,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.users[index],
                                              "funkcia",
                                              $$v
                                            )
                                          },
                                          expression: "users[index].funkcia"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  key: "konecny-uzivatel" + index,
                                  staticClass: "mb-4",
                                  attrs: { "no-gutters": "" }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "dynamic_check_box mt-0",
                                        attrs: {
                                          label: "Konečný užívateľ výhod"
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.dirty = true
                                          }
                                        },
                                        model: {
                                          value: _vm.users[index].kuv,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.users[index],
                                              "kuv",
                                              $$v
                                            )
                                          },
                                          expression: "users[index].kuv"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }),
                          _c("v-divider")
                        ]
                      : _vm._e(),
                    this.formaPodnikania.pkId == 2
                      ? [
                          _c(
                            "v-row",
                            {
                              staticClass: "mb-2",
                              attrs: { "no-gutters": "" }
                            },
                            [
                              _c("v-col", [
                                _c("h2", { staticClass: "left mr-3" }, [
                                  _vm._v("Konečný užívateľ výhod")
                                ])
                              ])
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "mb-2",
                              attrs: { "no-gutters": "" }
                            },
                            [
                              _c("v-col", { attrs: { cols: "8" } }, [
                                _c("p", { staticClass: "f16 gs100 mb-0" }, [
                                  _vm._v(
                                    " Pred odoslaním ponuky na schválenie skontrolujte zadaného konečného užívateľa výhod (KUV). "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " V prípade, ak je KUV aj iná osoba, pridajte ho pomocou tlačidla “Pridať nového KUV”. "
                                  )
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._l(_vm.users, function(user, index) {
                            return [
                              _c(
                                "v-row",
                                { key: "user" + index, staticClass: "mt-8" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass:
                                          "dynamic-input-control mb-10px",
                                        attrs: {
                                          value:
                                            user.meno + " " + user.priezvisko,
                                          label: "Konečný užívateľ výhod",
                                          disabled: "",
                                          "hide-details": "",
                                          outlined: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          })
                        ]
                      : _vm._e(),
                    _vm._l(_vm.kuv, function(user, index) {
                      return [
                        _c(
                          "v-card",
                          {
                            key: "kuv" + index,
                            staticClass: "mt-4 dialog-card card-item gap-4 pa-4"
                          },
                          [
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  { staticClass: "pr-2", attrs: { cols: "4" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass:
                                        "dynamic-input-control required",
                                      attrs: {
                                        label: "Meno",
                                        rules: [_vm.rules.required],
                                        outlined: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.dirty = true
                                        }
                                      },
                                      model: {
                                        value: _vm.kuv[index].meno,
                                        callback: function($$v) {
                                          _vm.$set(_vm.kuv[index], "meno", $$v)
                                        },
                                        expression: "kuv[index].meno"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ml-2 pl-2",
                                    attrs: { cols: "4" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      staticClass:
                                        "dynamic-input-control required",
                                      attrs: {
                                        label: "Priezvisko",
                                        rules: [_vm.rules.required],
                                        outlined: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.dirty = true
                                        }
                                      },
                                      model: {
                                        value: _vm.kuv[index].priezvisko,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.kuv[index],
                                            "priezvisko",
                                            $$v
                                          )
                                        },
                                        expression: "kuv[index].priezvisko"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "pa-0 predmet-expand btn-secondary btn-icon",
                                    staticStyle: { "margin-left": "auto" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteKUV(index)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("$trash")])],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              {
                                key: "user" + index,
                                attrs: { "no-gutters": "" }
                              },
                              [
                                _c(
                                  "v-col",
                                  { staticClass: "pr-1", attrs: { cols: "4" } },
                                  [
                                    _c("DatePicker", {
                                      staticClass: "required",
                                      attrs: {
                                        label: "Dátum narodenia",
                                        "hide-error-icon": "",
                                        placeholder: "DD/MM/YYYY",
                                        rules: [_vm.rules.required],
                                        required: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.dirty = true
                                        }
                                      },
                                      model: {
                                        value: _vm.kuv[index].datumNarodenia,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.kuv[index],
                                            "datumNarodenia",
                                            $$v
                                          )
                                        },
                                        expression: "kuv[index].datumNarodenia"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ml-2 pl-2",
                                    attrs: { cols: "4" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      staticClass:
                                        "dynamic-input-control required",
                                      attrs: {
                                        label: "Rodné číslo",
                                        rules: _vm.getRulesRodCislo(user),
                                        outlined: ""
                                      },
                                      on: {
                                        input: function(v) {
                                          return _vm.onRodneCisloInput(v, user)
                                        },
                                        change: function($event) {
                                          _vm.dirty = true
                                        }
                                      },
                                      model: {
                                        value: _vm.kuv[index].rodneCislo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.kuv[index],
                                            "rodneCislo",
                                            $$v
                                          )
                                        },
                                        expression: "kuv[index].rodneCislo"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  { staticClass: "pr-2", attrs: { cols: "4" } },
                                  [
                                    _c("v-checkbox", {
                                      class: {
                                        dynamic_check_box: true
                                      },
                                      staticStyle: {
                                        "white-space": "nowrap",
                                        "margin-top": "0px"
                                      },
                                      attrs: {
                                        label: "Zahraničná osoba",
                                        "hide-details": ""
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.dirty = true
                                        }
                                      },
                                      model: {
                                        value: _vm.kuv[index].zahranicnaOsoba,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.kuv[index],
                                            "zahranicnaOsoba",
                                            $$v
                                          )
                                        },
                                        expression: "kuv[index].zahranicnaOsoba"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }),
                    _c(
                      "v-row",
                      { staticClass: "mt-4", attrs: { "no-gutters": "" } },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "4" } },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-secondary",
                                on: {
                                  click: function($event) {
                                    return _vm.addKUV()
                                  }
                                }
                              },
                              [
                                _c("v-icon", { staticClass: "text-body-2" }, [
                                  _vm._v("mdi-plus")
                                ]),
                                _vm._v(" Pridať nového KUV")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  2
                )
              ]
            : [
                _vm.dlznik.length > 0
                  ? _c("DodatocneInfoScoringForm", {
                      key: "dlznik",
                      ref: "dlznik",
                      attrs: {
                        spoludlznik: false,
                        value: _vm.dlznik,
                        cislo_plz: _vm.variant.cislo_plz
                      },
                      on: {
                        changeDirty: function() {
                          return (_vm.dirty = true)
                        },
                        checkRequireSpoludlznik: function(val) {
                          return _vm.checkRequireSpoludlznik(val)
                        }
                      }
                    })
                  : _vm._e(),
                !_vm.jeSpoludlznik
                  ? _c(
                      "v-card",
                      { staticClass: "mt-24px card" },
                      [
                        _c(
                          "v-row",
                          { staticClass: "mb-4" },
                          [
                            _c("v-col", [
                              _c("h2", { staticClass: "left mr-3" }, [
                                _vm._v("Spolužiadateľ")
                              ])
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "mt-8" },
                          [
                            _c(
                              "v-col",
                              {
                                staticStyle: { "align-self": "end" },
                                attrs: { cols: "4" }
                              },
                              [
                                _c("v-checkbox", {
                                  class: {
                                    dynamic_check_box: true
                                  },
                                  staticStyle: {
                                    "white-space": "nowrap",
                                    "margin-top": "0px"
                                  },
                                  attrs: {
                                    label: "Chcem pridať spolužiadateľa",
                                    disabled: _vm.requiredSpoludlznik
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.dirty = true
                                    }
                                  },
                                  model: {
                                    value: _vm.pridanieSpoludlznika,
                                    callback: function($$v) {
                                      _vm.pridanieSpoludlznika = $$v
                                    },
                                    expression: "pridanieSpoludlznika"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.pridanieSpoludlznika
                          ? _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticStyle: { "align-self": "end" },
                                    attrs: { cols: "8" }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "sumar-dodat-info-label" },
                                      [
                                        _vm._v(
                                          "Pred odoslaním ponuky na schválenie je potrebné, aby mal spolužiadateľ vytvorený účet a overenú totožnosť. Link na registráciu zašleme spolužiadateľovi e-mailom."
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.pridanieSpoludlznika
                          ? _c(
                              "v-row",
                              { staticClass: "mt-4" },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticStyle: { "align-self": "end" },
                                    attrs: { cols: "4" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      staticClass:
                                        "dynamic-input-control required",
                                      attrs: {
                                        label: "E-mail spolužiadateľa",
                                        rules: [
                                          _vm.rules.email,
                                          _vm.rules.required
                                        ],
                                        outlined: ""
                                      },
                                      on: {
                                        change: _vm.onChangeEmailSpoludlznika
                                      },
                                      model: {
                                        value: _vm.emailSpoludlznika,
                                        callback: function($$v) {
                                          _vm.emailSpoludlznika = $$v
                                        },
                                        expression: "emailSpoludlznika"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.jeSpoludlznik ||
                (_vm.spoludlznik.length > 1 &&
                  _vm.pridanieSpoludlznika &&
                  _vm.jeDealer())
                  ? _c("DodatocneInfoScoringForm", {
                      key: "spoludlznik",
                      ref: "spoludlznik",
                      attrs: {
                        spoludlznik: true,
                        value: _vm.spoludlznik,
                        cislo_plz: _vm.variant.cislo_plz
                      },
                      on: {
                        changeDirty: function() {
                          return (_vm.dirty = true)
                        }
                      }
                    })
                  : _vm._e()
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }